var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{staticClass:"text-h4 text--primary",attrs:{"cols":"12"}},[_vm._v(" Thank You "+_vm._s(_vm.customer.name)+". ")]),_c('v-col',{staticClass:"text-h5",attrs:{"cols":"12"}},[_vm._v(" Ultimate Finance appreciates your business. ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }